import React, { Component } from 'react'

const presses = {
  press1: {
    img: 'assets/images/auto_reporter.jpg',
    name: 'Request Service',
    link:
      'http://www.theautoreporter.com/exclusive-automech-concierge-service-delivers-vehicles-seattle-customers/'
  },
  press2: {
    img: 'assets/images/GeekWire-logo-transparent.png',
    name: 'Get Multiple Quotes',
    link: 'https://www.geekwire.com/2018/automech/'
  },
  press3: {
    img: 'assets/images/microsoft_alumni.png',
    name: 'Finalize Appointment',
    link: 'https://www.microsoftalumni.com/s/1769/index-social.aspx?sid=1769&gid=2&pgid=1276'
  }
}

const style = {
  paddingLeft: '10px',
  paddingRight: '10px'
}

const imageStyle1 = {
  minHeight: '15px',
  maxHeight: '35px'
}

const imageStyle2 = {
  minHeight: '15px',
  maxHeight: '50px'
}

const imageStyle3 = {
  minHeight: '25px',
  maxHeight: '60px'
}

class Press extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hovering1: false,
      hovering2: false,
      hovering3: false
    }

    this.activatePressLogo1 = this.activatePressLogo1.bind(this)
    this.fadePressLogo1 = this.fadePressLogo1.bind(this)
    this.activatePressLogo2 = this.activatePressLogo2.bind(this)
    this.fadePressLogo2 = this.fadePressLogo2.bind(this)
    this.activatePressLogo3 = this.activatePressLogo3.bind(this)
    this.fadePressLogo3 = this.fadePressLogo3.bind(this)
  }

  activatePressLogo1() {
    //activate selected step
    this.setState({ hovering1: true })
  }

  fadePressLogo1() {
    //activate selected step
    this.setState({ hovering1: false })
  }

  activatePressLogo2() {
    //activate selected step
    this.setState({ hovering2: true })
  }

  fadePressLogo2() {
    //activate selected step
    this.setState({ hovering2: false })
  }

  activatePressLogo3() {
    //activate selected step
    this.setState({ hovering3: true })
  }

  fadePressLogo3() {
    //activate selected step
    this.setState({ hovering3: false })
  }

  render() {
    return (
      <div className={'columns has-text-centered is-centered is-mobile'} style={style}>
        <div
          className={'column autoreporter-logo press-logo' + (this.state.hovering1 ? '' : ' dull')}
          onMouseEnter={this.activatePressLogo1}
          onMouseLeave={this.fadePressLogo1}
        >
          <a href={presses.press1.link} target="_blank">
            <img src={presses.press1.img} style={imageStyle1} />
          </a>
        </div>
        <div
          className={'column press-logo' + (this.state.hovering2 ? '' : ' dull')}
          onMouseEnter={this.activatePressLogo2}
          onMouseLeave={this.fadePressLogo2}
          style={{ paddingTop: '5px' }}
        >
          <a href={presses.press2.link} target="_blank">
            <img src={presses.press2.img} style={imageStyle2} />
          </a>
        </div>
        <div
          className={'column press-logo' + (this.state.hovering3 ? '' : ' dull')}
          onMouseEnter={this.activatePressLogo3}
          onMouseLeave={this.fadePressLogo3}
          style={{ paddingTop: '5px' }}
        >
          <a href={presses.press3.link} target="_blank">
            <img src={presses.press3.img} style={imageStyle3} />
          </a>
        </div>
      </div>
    )
  }
}

export default Press



// WEBPACK FOOTER //
// ./src/components/home/Press.js